// import React from 'react';
// import ErrorMessage from './ErrorMessage';
// import styles from './DynamicFormRenderer.module.css';

// const RatingInput = ({ question, index, value, onChange, error, isSubmitted }) => {
//     const min = question.scale?.min || 1;
//     const max = question.scale?.max || 5;

//     return (
//         <div className={styles.questionWrapper}>
//             <div className={styles.questionHeader}>
//                 <span className={styles.questionNumber}>Q{index + 1}</span>
//                 <label className={styles.questionLabel}>
//                     {question.text}
//                     {question.required && <span className={styles.required}>*</span>}
//                 </label>
//             </div>
//             <div className={styles.ratingWrapper}>
//                 <div className={styles.ratingButtons}>
//                     {Array.from({ length: max - min + 1 }, (_, i) => i + min).map((rating) => (
//                         <button
//                             key={rating}
//                             type="button"
//                             onClick={() => !isSubmitted && onChange(rating)}
//                             disabled={isSubmitted}
//                             className={`${styles.ratingButton} ${value === rating ? styles.ratingButtonActive : ''} ${isSubmitted ? styles.disabled : ''}`}
//                         >
//                             {rating}
//                         </button>
//                     ))}
//                 </div>
//                 {question.scale?.labels && question.scale.labels.length > 0 && (
//                     <div className={styles.ratingLabels}>
//                         <span className={styles.ratingLabelStart}>{question.scale.labels[0]}</span>
//                         <span className={styles.ratingLabelEnd}>{question.scale.labels[question.scale.labels.length - 1]}</span>
//                     </div>
//                 )}
//             </div>
//             {error && <ErrorMessage message={error} />}
//         </div>
//     );
// };

// export default RatingInput;

import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const RatingInput = ({ question, index, value, onChange, error, isSubmitted, disabled = false, onBlur }) => {
    const min = question.scale?.min || 1;
    const max = question.scale?.max || 5;
    const isFormDisabled = disabled;

    const handleClick = (rating) => {
        if (isFormDisabled) return;
        onChange(rating);
        // Note: Reason modal is now handled by handleImmediateFieldChange in DynamicForm
    };

    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                </label>
            </div>
            <div className={styles.ratingWrapper}>
                <div className={styles.ratingButtons}>
                    {Array.from({ length: max - min + 1 }, (_, i) => i + min).map((rating) => (
                        <button
                            key={rating}
                            type="button"
                            onClick={() => handleClick(rating)}
                            disabled={isFormDisabled}
                            className={`${styles.ratingButton} ${value === rating ? styles.ratingButtonActive : ''} ${isFormDisabled ? styles.disabled : ''}`}
                        >
                            {rating}
                        </button>
                    ))}
                </div>
                {question.scale?.labels && question.scale.labels.length > 0 && (
                    <div className={styles.ratingLabels}>
                        <span className={styles.ratingLabelStart}>{question.scale.labels[0]}</span>
                        <span className={styles.ratingLabelEnd}>{question.scale.labels[question.scale.labels.length - 1]}</span>
                    </div>
                )}
            </div>
            {error && <ErrorMessage message={error} />}
        </div>
    );
};

export default RatingInput;